<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col class="col-values">
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="$router.push(`/gestao-territorios/${tabType}/0/edit`)"
        >
          Adicionar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="values"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template slot="no-data">
            <span> Nenhum Responsável </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              outlined
              color="warning"
              class="mr-3"
              @click="
                $router.push(
                  `/gestao-territorios/${tabType}/${item.responsavelId}/edit`
                )
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// import modalDelete from "./modalDelete";
import { territorioResponsavelAPI } from "@/modules/gestao-territorios/API/territorioResponsavelAPI";

export default {
  components: {
    // modalDelete,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Ações", value: "actions" },
      ],
      values: [],
      tabType: this.$route.params.tab,
      search: "",
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    load() {
      this.setLoading(true);
      territorioResponsavelAPI
        .list()
        .then(({ data }) => {
          this.values = data;
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao listar Responsáveis");
          console.log("Erro no List Territorios Responsáveis ", err);
        });
    },
  },

  mounted() {
    this.load();
  },
};
</script>
<style scoped lang="scss">
.col-values {
  display: flex;
  justify-content: flex-end;
}

.share-link {
  background: #5c8bb9 !important;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10%;
  width: 80%;
  .v-icon {
    color: #ffffff !important;
  }

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
      rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
      rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  }
}
</style>
